module.exports = __webpack_public_path__ + "img/icon-chevron-down.54dd2124.svg";